import { Injectable } from "@angular/core";
import { EventBridgeService } from "~app/common/services/event-bridge.service";

@Injectable({
    providedIn: "root"
})
export class PlaneraKartaEventService extends EventBridgeService {
}
